import { REPORTS_BASE_URL } from '@config';

export default userId => {
  window.open(
    `${REPORTS_BASE_URL}/vim2/webscript/output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=SBEagleScoutRankApplication&ScriptCode=ProcessPrintEditablePDF&UserID=${userId}`,
    '_blank',
  );
};
